import { FC, useContext, useMemo } from 'react'

import { Layout, Typography } from '@/components/ui'

import { sortTasksByAdded } from '@/utils/sortTasksByAdded'

import { ContentList, ShotlistUpload, TasksList } from './components'
import { DraftsContext } from './components/shotlistUpload/DraftsContext'
import { useHome } from './hooks/useHome'

const Home: FC = () => {
	const { tasks, listeners } = useHome()
	const { drafts } = useContext(DraftsContext)

	const mergedTasks = useMemo(() => {
		if (!tasks) return []
		return tasks.map(task => {
			const draft = drafts.find(d => d.id === task.id)
			return draft
				? {
						...task,
						status: draft.draft.status,
						has_video: draft.draft.has_video
				  }
				: task
		})
	}, [tasks, drafts])

	const sortedTasks = sortTasksByAdded(mergedTasks)

	return (
		<Layout className='flex'>
			<ShotlistUpload />
			<div className='flex flex-col gap-16 px-20 py-16 w-3/4'>
				{listeners?.length ? (
					<TasksList listeners={listeners} />
				) : (
					<Typography
						variant='text-xlarge'
						className='flex mx-auto items-center text-center text-gray-700'
					>
						No listeners available.
					</Typography>
				)}
				{sortedTasks.length ? (
					<ContentList tasks={sortedTasks} />
				) : (
					<Typography
						variant='text-xlarge'
						className='flex mx-auto items-center text-center text-gray-700'
					>
						No files uploaded yet.
						<br /> Upload a file to get started
					</Typography>
				)}
			</div>
		</Layout>
	)
}

export default Home
